import api from "PFCore/api";
import { ProfileMinimized } from "PFTypes";

export type SaveParticipantPayload = {
  conversationId: number;
  profileId: number;
};

type SaveParticipantResponse = {
  entries: ProfileMinimized[];
  meta: { total: number };
};

export const saveParticipant = ({
  profileId,
  conversationId
}: SaveParticipantPayload): Promise<SaveParticipantResponse> =>
  api({
    url: "chat/participants",
    method: "POST",
    data: {
      conversationId,
      profileId
    }
  });
